module.exports = __webpack_public_path__ + "img/collection-engagementRingsGold@2x.198df70.webp";